import React from 'react';
import { string } from 'prop-types';
import styled from 'styled-components';
import { animateScroll as scroll } from 'react-scroll';
import { ArrowUp } from 'react-feather';
const Button = styled.button`
  background: ${({ theme }) => theme.buttonBackground};
  border: 2px solid ${({ theme }) => theme.buttonBorder};
  color: ${({ theme }) => theme.text};
  border-radius: 30px;
  cursor: pointer;
  font-size:0.8rem;
  padding: 0.6rem;
  }`;

const ScrollTop = ({ theme }) => {
  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  return (
    <div>
      <Button id='scroll-top' onClick={scrollToTop}>
        <ArrowUp className='social-icons' /> Back to Top
      </Button>
    </div>
  );
};
ScrollTop.propTypes = {
  theme: string.isRequired,
};

export default ScrollTop;
